import {Trans, useTranslation} from 'react-i18next'

import {Button, CustomerIdentity, DialogNew, TextLink} from '@sdox/ui'
import {useCurrentContactPerson, useCurrentOffice} from '@sdox/api'

import {useCookies} from '../../../../hooks/useCookies'
import {DialogContent, useFirstVisitDialogStore} from '../FirstVisitDialog'

export const CookieConsentContent = () => {
  const office = useCurrentOffice()
  const contactPerson = useCurrentContactPerson()
  const options = office?.cookieContext.cookieOptions ?? undefined
  const {acceptAllCookies, revokeAllCookies} = useCookies({cookieOptions: options})
  const {t} = useTranslation()
  const selectDialogContent = useFirstVisitDialogStore(state => state.selectDialogContent)
  const imprintUrl = office?.imprintUrl ?? ''

  const onAccept = () => {
    acceptAllCookies()
    selectDialogContent(DialogContent.Closed)
  }

  const onReject = () => {
    revokeAllCookies()
    selectDialogContent(DialogContent.Closed)
  }

  return (
    <>
      <DialogNew.Content
        className={'pt-spacing-16'}
      >
        <div className={'flex flex-col'}>
          {contactPerson && (
            <CustomerIdentity
              className={'mb-4'}
              name={contactPerson?.fullName}
              avatarHref={contactPerson?.thumbnail ?? undefined}
              text={t('eufe:folderSendText')}
              size={'medium'}
            />
          )}
          <p className={'text-sm sm:text-base'}>
            <Trans
              i18nKey={'eufe:cookiesText'}
              tOptions={{joinArrays: ' '}}
              components={{
                1: (
                  <TextLink
                    onClick={(e) => {
                      e.preventDefault()
                      selectDialogContent(DialogContent.CookiePolicy)
                    }}
                  />
                ),
                2: (
                  <TextLink
                    onClick={(e) => {
                      e.preventDefault()
                      selectDialogContent(DialogContent.PrivacyPolicy)
                    }}
                  />
                ),
                3: (
                  <TextLink
                    onClick={(e) => {
                      e.preventDefault()
                      window.open(imprintUrl, '_blank')
                    }}
                  />
                ),
              }}
            />
          </p>
          {/*  HACK: avoid focus on first button */}
          <button
            tabIndex={0}
            className={'outline-none focus-visible:outline-none'}
          />
        </div>
      </DialogNew.Content>
      <DialogNew.Footer className={'flex flex-col gap-spacing-12 sm:flex-row sm:justify-end'}>
        <Button
          variant={'outline'}
          onClick={() => selectDialogContent(DialogContent.CookieSettings)}
          size={'medium'}
        >
          {t('common:settings')}
        </Button>
        <Button
          variant={'filled-brand'}
          onClick={onReject}
          size={'medium'}
        >
          {t('common:reject')}
        </Button>
        <Button
          variant={'filled-brand'}
          onClick={onAccept}
          size={'medium'}
        >
          {t('common:acceptAndClose')}
        </Button>
      </DialogNew.Footer>
    </>
  )
}
